import React, { useState } from 'react';
import { Badge, Modal, ModalBody} from 'reactstrap';
import {
    IconAssessment,

  } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../../i18n/useTranslation';
const AssessmentBadge = ({ userData, userEmail, userSender, cleanStudentGrade, obtainCountryName }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [formUrl, setFormUrl] = useState('');
    const { translate } = useTranslation()
    const handleClick = () => {
      const queryParams = new URLSearchParams({
        'studentName[first]': userData?.firstName || '',
        'studentName[last]': userData?.lastName || '',
        'studentType':
          userData?.studentInfo?.studentType?.charAt(0).toUpperCase() +
            userData?.studentInfo?.studentType?.slice(1) || '',
        'studentEmail': userEmail,
        'parentName[first]': userData?.studentInfo?.parents?.[0]?.firstName || '',
        'parentName[last]': userData?.studentInfo?.parents?.[0]?.lastName || '',
        'parentEmail': userData?.studentInfo?.parents?.[0]?.email || '',
        'sender': `${userSender?.firstName || ''} ${userSender?.lastName || ''}`,
        'grade': cleanStudentGrade(userData?.studentInfo?.grade),
        'country': obtainCountryName(userData?.countryId),
      }).toString();
  
      const fullUrl = `https://form.jotform.com/72844540742155?${queryParams}`;
      setFormUrl(fullUrl);
      setModalOpen(true);
    };
  
    return (
      <>
        <Badge
          className="badge badge-pill d-flex flex-row align-items-center py-1"
          style={{
            backgroundColor: '#FFA336',
            cursor: 'pointer',
            outline: 'none',
            boxShadow: 'none',
          }}
          onClick={handleClick}
        >
          <IconAssessment className="mr-1" size={16} color="#FFFFFF" />
          <span style={{ color: '#FFFFFF' }}>{translate('profile.modal.buttons.assesstment')}</span>
        </Badge>
  
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="lg"
                    style={{
                        maxWidth: '1000px',
                        width: '90%',
                      }}
                      >
          <ModalBody style={{ padding: 0, height: '90vh', width: '90vh', overflow: 'hidden'}}>
            <iframe
              title="Assessment Form"
              src={formUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                overflow: 'hidden',
              }}
            />
          </ModalBody>
        </Modal>
      </>
    );
  };
export default AssessmentBadge;
